<div class="mb-3 message-card">
  <mwp-text-translate text="Underwriting guidelines require that you provide the following information to continue." jsonKey="eligibilityUnderwritingGuidelines" />
</div>
<div class="mb-4 content-container table-comp">
  @for (eligibilityGrid of eligibilityGrids; track eligibilityGrid) {
    <div class="title fw-bold">
      {{eligibilityGrid.title}}
    </div>
    <div class="content">
      <div class="mb-1 p-2 fw-bold">
        <div [innerHTML]="eligibilityGrid.question | pipeSafeHTML "></div>
      </div>
      <hr class="m-0">
      <table>
        <thead>
          <tr class="no-side-borders">
            <th style="width: 12%; padding:1rem;">
              <mwp-text-translate text="Response" jsonKey="response" />
            </th>
            <th style="padding:1rem;">
              <mwp-text-translate text="Covered Member" jsonKey="coveredMember" />
            </th>
            <th style="padding:1rem;">
              <mwp-text-translate text="Relationship" jsonKey="relationship" />
            </th>
          </tr>
        </thead>
        <tbody>
          @for (gridItem of eligibilityGrid.collection; track gridItem; let i = $index) {
            <tr class="no-side-borders">
              <td>
                <mat-button-toggle-group [hideSingleSelectionIndicator]="true">
                  <mat-button-toggle value="Yes" (change)="eligibilitySelection($event, gridItem.knockoutDependentID)">Yes</mat-button-toggle>
                  <mat-button-toggle value="No" (change)="eligibilitySelection($event, gridItem.knockoutDependentID)">No</mat-button-toggle>
                </mat-button-toggle-group>
              </td>
              <td>{{gridItem.coveredMemberName}}</td>
              <td>{{gridItem.relationship}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <div class="footer">
    <mwp-benefit-enrollment-wizard-control [isContinueDisabled]="!isPageValid" (emitComplete)="submitComplete()"></mwp-benefit-enrollment-wizard-control>
  </div>
</div>